import React, { useEffect, useRef } from "react";

export default function SlideInOutText2({ txt = "", prevTxt = "", fontSize, slideInColor = "white", slideOutColor = "white", tag = "span", style = {}, interval = 1500, italic = false }) {
  const wrapperRef = useRef(null);

  // Split text into characters
  const chars = txt.split("");
  const prevChars = prevTxt.split("");

  // Render each character as a slide-in/out span
  const Tag = tag;

  // Support slideOutColor as array or string, cycle with modulo
  const getSlideOutColor = (i) => {
    if (Array.isArray(slideOutColor) && slideOutColor.length > 0) {
      return slideOutColor[i % slideOutColor.length];
    }
    return slideOutColor;
  };

  useEffect(() => {
    if (!wrapperRef.current) return;
    const charSpans = wrapperRef.current.querySelectorAll(".slide-char-inner");
    // Add a delay before animating
    const delay = 180; // ms
    const timers = [];
    const animate = () => {
      chars.forEach((ch, i) => {
        if (prevChars[i] !== ch) {
          timers.push(setTimeout(() => {
            const span = charSpans[i];
            if (!span) return;
            span.style.transform = "translateY(-56%)";
            timers.push(setTimeout(() => {
              span.style.transform = "translateY(-6%)";
            }, 350));
          }, i * 60));
        }
      });
    };
    const delayTimer = setTimeout(animate, delay);
    timers.push(delayTimer);
    return () => timers.forEach(clearTimeout);
  }, [txt, prevTxt]);

  return (
    <Tag
      ref={wrapperRef}
      style={{
        display: "inline-block",
        fontWeight: 900,
        fontSize: fontSize,
        fontStyle: italic ? "italic" : "normal", 
        height : fontSize,
        overflow: "hidden",
        ...style,
      }}
    >
      {chars.map((ch, i) => (
        <span
          key={i}
          style={{
            display: "inline-block",
            verticalAlign: "top",
            overflow: "hidden",
            height: fontSize,
          }}
        >
          <span
            className="slide-char-inner"
            style={{
              display: "flex",
              flexDirection: "column",
              transition: "transform 0.4s cubic-bezier(.7,0,.3,1)",
              willChange: "transform",
              transform: "translateY(-6%)",
            }}
          >
            <span style={{ color: slideInColor, fontFamily: "Source Serif Pro, serif", padding : "0px 1px" }}>{ch}</span>
            <span style={{ color: getSlideOutColor(i), fontFamily: "Source Serif Pro, serif", padding : "0px 1px" }}>{prevChars[i] !== undefined ? prevChars[i] : ch}</span>
          </span>
        </span>
      ))}
    </Tag>
  );
}